import {array, object, string} from "yup"
import {useValidatorSeeker} from "@ui-seeker/app"

import {userSettingsTierFormData} from "../@signals"


const schema = object({
	name: string().required('Name is required'),
	providers: array().min(1, 'Providers is required')
})

export default function useUserSettingsTierValidator() {
	const { isValid, errors } = useValidatorSeeker(userSettingsTierFormData.value, schema)

	return {
		isValid,
		nameError: errors.name || null,
		providersError: errors.providers || null
	}
}